module.exports = __webpack_public_path__ + "static/project-13d-fe77658a26a5a8603ff9039867df54dd.png";